module.exports = __webpack_public_path__ + "static/media/quickto-collect.8c1cd643.svg";